import Vue from "vue";
import {
  documentTypesMixin,
  PersonService,
  ReservationService,
  validationMixin
} from "smck-service";
import {
  ApiClient,
  CustomHeadersService,
  FlashMessageService
} from "zoox-infra";
import {
  zCameraModal,
  zDatePicker,
  zValidationGuestModal
} from "zoox-components";
import Recaptcha from "@/components/shared/Recaptcha/index.vue";

import SessionMixin from "../../../shared/mixins/sessionMixin";
import get from "lodash/get";
import moment from "moment";
import StrategyManager from "@/strategies/manager";
import CompanyService from "../../../../service/company-service";
import ReservationServiceLocal from "../../../../service/reservation-service";
import { mapActions, mapState } from "vuex";
import PincodeInput from "vue-pincode-input";
import { zLanguageChanger } from "zoox-components";
import zModalPinError from "@/components/shared/zModalPinError";

export default {
  name: "Search",
  mixins: [validationMixin, documentTypesMixin, SessionMixin],
  components: {
    "z-date-picker": zDatePicker,
    "z-camera": zCameraModal,
    PincodeInput,
    "z-validation-guest-modal": zValidationGuestModal,
    "z-language-changer": zLanguageChanger,
    zModalPinError,
    Recaptcha
  },
  props: [
    "paramsReady",
    "customizationSettings",
    "fieldSettingsData",
    "additionalData",
    "companyParams",
    "currentCompany"
  ],
  watch: {
    paramsReady: function(value) {
      if (value) {
        this.setCompanyData(value);
      }
    }
  },
  data() {
    return {
      tab: 0,
      showModalPinError: false,
      showCloseModalButton: false,
      requireRecaptcha: false,
      resolvedRecaptcha: false,
      firstStepCheck: true,
      secondStepCheck: true,
      apiClient: new ApiClient(Vue),
      companyService: new CompanyService(),
      reservationLocalService: new ReservationServiceLocal(),
      loading: false,
      reconOpen: false,
      enableRecon: false,
      render: true,
      showBrowserModalRecomendation: false,
      reservationSearch: {
        reservationNumber: "",
        lastName: ""
      },
      documentSearch: {
        documentType: "",
        documentNumber: ""
      },
      emailSearch: {
        email: "",
        lastName: ""
      },
      nameSearch: {
        name: "",
        lastName: "",
        checkIn: null,
        checkOut: null
      },
      alreadyAuthenticated: false,
      checkInUntil: 0,
      reservationService: new ReservationService(Vue),
      personService: new PersonService(Vue),
      strategyManager: new StrategyManager(),
      datepickerConfig: {
        minDate: moment()
          .add(-1, "year")
          .utc()
          .toDate(),
        maxDate: moment()
          .add(1, "year")
          .utc()
          .toDate()
      },
      datepickerCheckinConfig: {
        minDate: moment()
          .add(-1, "year")
          .utc()
          .toDate(),
        maxDate: moment()
          .add(1, "year")
          .utc()
          .toDate()
      },
      showCameraModal: true,
      showGcButton: false,
      reservationStatus: {
        TO_CONFIRM: 0,
        CONFIRMED: 1,
        CHECK_IN: 2,
        CHECK_OUT: 3,
        PENDING: 4,
        NO_SHOW: 5,
        CANCELLED: 6,
        WAIT_LIST: 7,
        IN_ATTEMPT: 8
      },
      openFaceRecognitionModalForUserRegistered: false,
      radioGroupSelectValidationModel: null,
      radioGroupSelectValidationLabels: [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ],
      guestComunicationOptions: null,
      validationModalStep: 0,
      validationCode: null,
      showValidationModal: false,
      selectedGuest: null,
      lastReservations: null,
      currentReservation: null,
      enableRedirect: true,
      hasHashInRouter: false,
      portalSearchParametrization: [],
      portalSearchParametrizationLabels: [
        { enableSearchByName: this.$t("WELCOME.SEARCH_METHODS.NAME") },
        { enableSearchByDocument: this.$t("WELCOME.SEARCH_METHODS.DOCUMENT") },
        {
          enableSearchByEmailOrPhoneNumber: this.$t(
            "WELCOME.SEARCH_METHODS.EMAIL"
          )
        },
        {
          enableSearchByReservationNumber: this.$t(
            "WELCOME.SEARCH_METHODS.RESERVATION"
          )
        },
        {
          enableSearchByFacialRecognition: this.$t(
            "WELCOME.SEARCH_METHODS.RECOGNITION"
          )
        }
      ]
    };
  },
  computed: {
    ...mapState(["showSplashScreen"]),
    missingCaptcha() {
      if (this.requireRecaptcha && !this.resolvedRecaptcha) {
        return true;
      }

      return false;
    },
    searchMethods() {
      const searchMethods = this.portalSearchParametrization.map(
        (obj, index) => {
          return {
            value: index,
            text: obj[obj.parameter]
          };
        }
      );
      return searchMethods;
    },
    splashScreenContent() {
      switch (this.globalLocale) {
        case "pt":
          return get(this.customizationSettings, "splashScreenHtmlPt") || "";

        case "en":
          return get(this.customizationSettings, "splashScreenHtmlEn") || "";

        case "es":
          return get(this.customizationSettings, "splashScreenHtmlEs") || "";

        default:
          return get(this.customizationSettings, "splashScreenHtmlEn") || "";
      }
    },
    documentTypesData() {
      return this.documentTypes.filter(dt => dt.value !== 0);
    }
  },
  async created() {
    await this.onPortalSearchParametrization(
      this.companyService.getLocalCompany().id
    );
  },
  async mounted() {
    const { hash } = this.$route.params;

    Vue.$globalEvent.$on("onGuestControlRedirect", async () => {
      await this.guestControlRedirect();
    });

    Vue.$globalEvent.$on("languageChanged", () => {
      this.radioGroupSelectValidationLabels = [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ];
    });

    this.$resetState();
    this.tab = parseInt(this.$route.query.tab) || 0;

    if (this.paramsReady) {
      this.setCompanyData(false);
    }

    const company = this.companyService.getLocalCompany();

    this.whatStepShowFirst(company);

    // let isMobile = navigator.userAgent.match(
    //   /Android|webOS|iPhone|iPod|Blackberry/i
    // );

    if (
      this.$customization &&
      this.$customization.enableRedirect &&
      this.$customization.redirectTo === 0
    ) {
      this.showGcButton = true;
    }

    var ua = navigator.userAgent;
    if (
      (!/Chrome/i.test(ua) &&
        !/(CriOS\/){1}(\d{2}\.{1}\d{1}\.\d{4}\.\d{2}){1}( Mobile\/){1}(\d{2}E\d{3}){1}( Safari\/){1}(\d{3}\.{1}\d{1}){1}/i.test(
          ua
        )) || // Chrome UA on iPhone
      (/Chrome/i.test(ua) && /Edge/i.test(ua)) ||
      (/Chrome/i.test(ua) && /Edg/i.test(ua)) ||
      /Firefox/i.test(ua)
    ) {
      this.showBrowserModalRecomendation = true;
    }

    this.checkInUntil = this.currentCompany.checkInUntil;

    if (hash) {
      this.hasHashInRouter = true;
      this.strategyManager.startLoading();
      await this.checkValidationCode({
        hash: hash
      });
    }
  },
  methods: {
    ...mapActions([
      "$closeSplashScreen",
      "$setIsQualifiedGuest",
      "$setCurrentPhoto",
      "$setCameFromRecon",
      "$setAuthenticatedPersonGuestId",
      "$setIsSamePersonFromRecon"
    ]),
    async getReservation(companyId, reservationNumber) {
      const $context = this;
      try {
        const resp = await this.reservationLocalService.getRawReservation(
          companyId,
          reservationNumber
        );
        delete resp.links;

        this.lastReservations = [resp.reservation];
      } catch (error) {
        FlashMessageService.warning(
          $context.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
        );
        $context.$redirectSearch();
      }
    },
    whatStepShowFirst(company) {
      let enableGc = false;
      if (
        company &&
        company.parameters_sc &&
        company.parameters_sc.operation_flow &&
        company.parameters_sc.operation_flow.enableRedirect === true
      ) {
        enableGc = true;
      }

      if (!this.customizationSettings.splashScreenEnabled) {
        if (enableGc) this.firstStepCheck = true;
        else {
          if (this.enableRecon) {
            this.firstStepCheck = false;
            this.secondStepCheck = true;
          } else {
            this.firstStepCheck = false;
            this.secondStepCheck = false;
          }
        }
      }
    },
    nextStep() {
      this.firstStepCheck = false;
      if (this.enableRecon) this.secondStepCheck = true;
      else this.secondStepCheck = false;
    },
    checkFieldBelow() {
      if (this.documentSearch.documentNumber) {
        let x = this.documentSearch.documentType;
        let y = this.documentSearch.documentNumber;
        this.documentSearch.documentType = x;
        let mask = documentTypesMixin.methods.getDocumentMask(
          this.documentSearch.documentType.value
        );

        if (mask !== "") {
          this.documentSearch.documentNumber = "";
          for (var i = 0, j = 0; i < mask.length; i++) {
            if (mask.charAt(i) === "#") {
              this.documentSearch.documentNumber += y.charAt(j);
              j++;
            } else {
              this.documentSearch.documentNumber += mask.charAt(i);
            }
          }
        } else {
          this.documentSearch.documentNumber = y;
        }
      }
      this.$refs.documentForm[0].validate();
    },
    setCompanyData(reconValue) {
      this.setReconData(reconValue);
    },
    attemptsFail() {
      this.openFaceRecognitionModalForUserRegistered = false;
      this.firstStepCheck = false;
      this.secondStepCheck = false;
    },
    closeSplash() {
      if (!this.showGcButton) {
        if (this.enableRecon) {
          this.firstStepCheck = false;
          this.secondStepCheck = true;
        } else {
          this.firstStepCheck = false;
          this.secondStepCheck = false;
        }
      }
      this.$closeSplashScreen();
    },
    openModalForFaceRecognition() {
      this.openFaceRecognitionModalForUserRegistered = true;
    },
    goToSearch(value) {
      if (value == "no_face") {
        this.showCameraModal = false;
      }
      this.firstStepCheck = false;
    },
    setReconData(setReconValue) {
      let enableRecognition = get(
        this.currentCompany,
        ["parameters_sc", "globalSettings", "enableRecognition"],
        true
      );

      this.enableRecon =
        typeof enableRecognition === "undefined"
          ? this.enableRecon
          : enableRecognition;

      this.reconOpen = setReconValue;
    },
    changeCombo() {
      if (
        this.tab ===
        this.portalSearchParametrization.findIndex(
          x => x.parameter === "enableSearchByFacialRecognition"
        )
      ) {
        this.back();
      }
    },
    closeRecognitionModal() {
      if (
        this.portalSearchParametrization[0].parameter ===
        "enableSearchByFacialRecognition"
      ) {
        this.tab = 1;
      }
      this.openFaceRecognitionModalForUserRegistered = false;
    },
    goToSearchOptions() {
      this.secondStepCheck = false;
      if (
        this.portalSearchParametrization[0].parameter ===
        "enableSearchByFacialRecognition"
      ) {
        this.openFaceRecognitionModalForUserRegistered = true;
      }
    },
    reconSuccessForUserRegistered: function(resp) {
      this.openFaceRecognitionModalForUserRegistered = false;

      this.guestComunicationOptions = resp.resp.lastReservations[0].guests.filter(
        x => x.hasOwnProperty("personId")
      )[0].contactInfoList;

      this.lastReservations = resp.resp.lastReservations;
      this.selectedGuest = resp.resp.lastReservations[0].guests.find(x =>
        x.hasOwnProperty("personId")
      );
      this.$setCurrentPhoto(resp.image);
      this.showValidationModal = true;
    },
    async resendCode(value) {
      return this.sendCode(value);
    },
    async sendCode(value) {
      this.validationModalStep = 0;
      if (value) {
        return this.apiClient
          .post(`v2/portal/send-code`, {
            contactId: value.id,
            reservationNumber: this.lastReservations[0].reservationNumber
          })
          .then(resp => {
            if (resp.ok) {
              this.validationModalStep = 2;
            }
          });
      }
    },
    onPortalSearchParametrization: async function(id) {
      this.apiClient
        .get(`portal/${id}/portalSearchParametrization`)
        .then(data => {
          this.portalSearchParametrization = data;
          this.buildParametrizationArray(data);
        });
    },
    buildParametrizationArray(data) {
      const ordinationLabels = [];
      data.forEach(x => {
        ordinationLabels.push({
          ...this.portalSearchParametrizationLabels.find(
            l => Object.keys(l)[0] === Object.keys(x)[0]
          ),
          value: x[Object.keys(x)[0]],
          parameter: Object.keys(x)[0]
        });
      });

      this.portalSearchParametrization = ordinationLabels.filter(x => x.value);
    },
    closeValidationModal() {
      this.showValidationModal = false;
      this.guestComunicationOptions = null;
      this.validationModalStep = 0;
      this.validationCode = null;
    },
    async checkValidationCode(value) {
      if ((value.code && value.code.length === 5) || value.hash) {
        let BASE_URL = "";
        let contentRequisition = {};

        if (value.hash) {
          BASE_URL = `portal/verify-hash`;
          contentRequisition = {
            hash: value.hash
          };
        } else {
          BASE_URL = `portal/verify-code`;
          contentRequisition = {
            verificationCode: value.code,
            contactId: value.contactId
          };
        }

        try {
          const resp = await this.apiClient.post(
            BASE_URL,
            contentRequisition,
            null,
            false,
            false
          );

          if (value.hash) {
            CustomHeadersService.setCustomHeaders({
              Authorization: resp.token
            });

            const company = this.currentCompany;

            this.companyId = company.id;

            await this.getReservation(company.id, resp.reservationNumber);
            this.selectedGuest = this.lastReservations[0].guests.find(
              g => g.id === resp.guestId
            );
            await this.prepareReservation(resp, value);
            this.$setIsQualifiedGuest(true);
          } else {
            await this.prepareReservation(resp, value);
          }

          this.strategyManager.finishLoading();
          return resp;
        } catch (error) {
          if (error.status === 401) {
            FlashMessageService.error(this.$t("NOVO_FLUXO.INCORRECT_PIN"));
            this.$redirectSearch();
          } else if (error.status === 404) {
            if (value.hash) {
              this.showModalPinError = true;
              this.strategyManager.finishLoading();
            } else {
              FlashMessageService.error(this.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN"));
            }
            this.$redirectSearch();
          } else if (error.status === 408) {
            if (value.hash) {
              const { guestId, reservationId } = error.body.metadata;

              localStorage.setItem(
                "metadata-timeout-expiredPin",
                JSON.stringify({ reservationId, guestId })
              );
              localStorage.setItem("expiredPin", "true");

              this.$router.push({
                path: `/${reservationId}/${guestId}`
              });
            } else {
              FlashMessageService.error(this.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN"));
            }
          } else {
            FlashMessageService.error(this.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN"));
          }
        }
      }
    },
    async prepareReservation(resp, value) {
      if (resp.token) {
        this.showValidationModal = false;
        this.alreadyAuthenticated = true;
        CustomHeadersService.setCustomHeaders({
          Authorization: resp.token
        });

        const validated = {
          personId: resp.personId,
          validated: resp.validated
        };
        this.$setIsQualifiedGuest(true);
        this.$setCameFromRecon(true);
        this.reservationService.setValidatedInfo(validated);
        if (this.lastReservations && this.lastReservations.length > 1) {
          this.$setReservations(this.lastReservations);
          this.$setCurrentPersonId(resp.personId);
          this.$redirectMultReserva();
        } else {
          const reservation = this.lastReservations[0];
          reservation.guests = reservation.guests.map(g => {
            if (this.selectedGuest.personId === g.personId) {
              g.validated = resp.validated;
            }

            return g;
          });

          this.reservationService.setLocalReservation(reservation);

          let restUpdateLocalGuest;
          if (value.hash) {
            restUpdateLocalGuest = this.reservationService.updateLocalGuest(
              resp.guestId,
              validated
            );
          } else {
            restUpdateLocalGuest = this.reservationService.updateLocalGuest(
              this.selectedGuest.guestId,
              validated
            );
          }
          this.$setCurrentReservation(restUpdateLocalGuest);
          if (value.hash) {
            const reservationId = resp.reservationId;
            const guestId = resp.guestId;
            this.$setCurrentPersonId(resp.personId);
            if (this.selectedGuest.completedSteps.dataConfirmation) {
              this.$setCurrentMobileStep(4);
              this.$redirectGuestView(reservationId, guestId);
            } else {
              this.$redirectGuestView(reservationId, guestId);
            }
          } else {
            if (!(this.$route.name === "Search")) {
              if (this.$route.query.fromSearch === "true") {
                this.$setCurrentPersonId(resp.personId);
              } else {
                this.alreadyAuthenticated = false;
              }
            } else {
              if (this.alreadyAuthenticated) {
                this.$setCurrentPersonId(resp.personId);
              }
            }
            if (reservation.guests.length > 1)
              this.$handleMultipleGuests(
                reservation,
                true,
                this.alreadyAuthenticated
              );
            else {
              this.$setIsSamePersonFromRecon(true);
              this.$redirectGuestView(reservation.id, this.selectedGuest.id);
            }
          }
        }
      }
    },
    reconSuccess: function() {
      // const person = resp.personList[0];
      //this.getReservationFromPersonList(resp.personList, resp.image, person.id);

      this.reconOpen = false;
      this.$_gtagPlugin_trackEvent("SEARCH_REKOGNITION_SUCCESS", "PORTAL");
    },
    reconFailForUserRegistered: function() {
      this.openFaceRecognitionModalForUserRegistered = false;
      const indexRecognitionParam = this.portalSearchParametrization.findIndex(
        x => x.parameter === "enableSearchByFacialRecognition"
      );
      if (indexRecognitionParam !== -1 && indexRecognitionParam === 0)
        this.tab++;
      else this.tab--;
    },
    reconFail: function() {
      this.reconOpen = false;
      this.$_gtagPlugin_trackEvent("SEARCH_REKOGNITION_FAIL", "PORTAL");
    },
    reservationSubmit: function() {
      if (this.$refs.reservationForm[0].validate()) {
        this.loading = true;
        this.findReservation(
          this.reservationSearch.reservationNumber,
          null,
          null,
          null,
          null,
          this.reservationSearch.lastName,
          null,
          null
        );
      }
    },
    goToFillFnrhWithoutRecognition() {
      this.closeValidationModal();
      this.$setReservations(this.lastReservations);
      this.$setCurrentPersonId(this.selectedGuest.personId);
      this.$redirectMultReserva();
    },
    documentSubmit: function() {
      this.$_gtagPlugin_trackEvent(
        "SEARCH_BY_DOCUMENT",
        "PORTAL",
        this.documentSearch.documentNumber
      );
      if (this.$refs.documentForm[0].validate()) {
        const task = this.reservationService.getByDocument({
          documentTypeId: this.documentSearch.documentType.value,
          documentNumber: this.documentSearch.documentNumber,
          birthdate: this.documentSearch.birthdate
        });
        this.handleReservationListResponse(task);
      }
    },
    emailSubmit: function() {
      this.$_gtagPlugin_trackEvent(
        "SEARCH_BY_EMAIL",
        "PORTAL",
        this.emailSearch.email
      );
      if (this.$refs.emailForm[0].validate()) {
        this.loading = true;
        this.findReservation(
          null,
          null,
          null,
          this.emailSearch.email,
          null,
          this.emailSearch.lastName,
          null,
          null
        );
      }
    },

    nameSubmit: function() {
      this.$_gtagPlugin_trackEvent(
        "SEARCH_BY_NAME",
        "PORTAL",
        this.nameSearch.name
      );
      if (this.$refs.nameForm[0].validate()) {
        const checkinDate = moment(this.nameSearch.checkIn);
        const checkoutDate = moment(this.nameSearch.checkOut);
        const now = moment()
          .millisecond(0)
          .second(0)
          .minute(0)
          .hour(0);

        if (checkinDate.isAfter(checkoutDate)) {
          FlashMessageService.warning(
            this.$t("WELCOME.CHECKIN_GREATER_THAN_CHECKOUT")
          );
          this.loading = false;
          return;
        } else if (checkinDate.diff(now) < 0) {
          FlashMessageService.warning(
            this.$t("WELCOME.CHECKIN_MUST_BE_GREATER_THAN_TODAY")
          );
          this.loading = false;
          return;
        } else if (checkoutDate.diff(now) <= 0) {
          FlashMessageService.warning(
            this.$t("WELCOME.CHECKOUT_MUST_BE_GREATER_THAN_TODAY")
          );
          this.loading = false;
          return;
        }

        this.loading = true;
        this.findReservation(
          null,
          null,
          null,
          null,
          this.nameSearch.name,
          this.nameSearch.lastName,
          this.nameSearch.checkIn,
          this.nameSearch.checkOut
        );
      }
    },
    findReservation: async function(
      reservationNumber,
      documentTypeId,
      documentNumber,
      email,
      name,
      lastName,
      checkinDate,
      checkoutDate,
      personId,
      birthdate
    ) {
      if (this.requireRecaptcha && !this.resolvedRecaptcha) {
        return;
      }

      const company = this.currentCompany;
      if (company && company.id) {
        this.companyId = company.id;
      }

      if (reservationNumber) {
        reservationNumber = encodeURIComponent(reservationNumber);
      }

      this.reservationService
        .getAll(
          this.companyId,
          reservationNumber,
          documentTypeId,
          documentNumber,
          name,
          lastName,
          email,
          checkinDate,
          checkoutDate,
          birthdate
        )
        .then(async resp => {
          this.loading = false;
          if (resp && resp.data && resp.data.length > 0) {
            if (resp.data && resp.data.length > 0) {
              const reservationsConfirmed = resp.data.filter(
                item => item.resStatus === 1
              );

              if (reservationsConfirmed.length === 0) {
                if (reservationNumber) {
                  let status = resp.data[0].resStatus;
                  const statusFound = Object.keys(this.reservationStatus).find(
                    key => {
                      return (
                        this.reservationStatus[key] === resp.data[0].resStatus
                      );
                    }
                  );
                  if (statusFound) {
                    status = this.$t(`GLOBAL.${statusFound}`);
                  }
                  FlashMessageService.warning(
                    `${this.$t(
                      "GLOBAL_ERROR.RESERVATION_CANNOT_BE_UPDATED_BY_STATUS"
                    )}${status}`
                  );
                } else {
                  this.notFound();
                }
              } else {
                resp.data = reservationsConfirmed;
                resp.meta.total = reservationsConfirmed.length;
                if (resp.data && resp.data.length > 1) {
                  let reservationWithFnrh = [];

                  resp.data.map(reservation => {
                    let exists = false;

                    reservation.guests.map(
                      guest => guest.fnrhId && (exists = true)
                    );

                    if (exists) reservationWithFnrh.push(reservation);
                  });

                  if (reservationWithFnrh.length === resp.data.length) {
                    FlashMessageService.warning(
                      this.$t("SUCCESS.PRECHICKIN_ALREADY_FILLED")
                    );
                  } else {
                    this.$setReservations(resp.data);
                    if (personId) this.$setCurrentPersonId(personId);
                    this.$redirectMultReserva();
                  }
                } else {
                  const reservation = resp.data[0];
                  const reservationWithOrder = await this.reservationService.getById(
                    {
                      reservationId: reservation.id
                    }
                  );
                  this.reservationService.setLocalReservation(
                    reservationWithOrder
                  );
                  this.$setCurrentReservation(reservationWithOrder);
                  if (!(this.$route.name === "Search")) {
                    if (this.$route.query.fromSearch === "true") {
                      this.$setCurrentPersonId(personId);
                    } else {
                      this.alreadyAuthenticated = false;
                    }
                  } else {
                    if (this.alreadyAuthenticated) {
                      this.$setCurrentPersonId(personId);
                    }
                  }
                  this.$handleMultipleGuests(
                    reservation,
                    true,
                    this.alreadyAuthenticated
                  );
                }
              }
            } else {
              this.notFound();
            }
          } else {
            this.notFound();
          }
        })
        .catch(err => {
          if (err.status == 429) {
            this.requireRecaptcha = true;
          } else if (err.status === 423) {
            FlashMessageService.warning(
              this.$t("WELCOME.SEARCH_RESERVATION_BLOCKED")
            );
          }

          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    notFound: function() {
      FlashMessageService.warning(
        this.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
      );
    },
    back: function() {
      this.reconOpen = true;
      this.openFaceRecognitionModalForUserRegistered = true;
    },
    async guestControlRedirect() {
      const company = this.currentCompany;

      // GuestControl strategy
      await this.strategyManager.setStrategy(0);
      await this.strategyManager.redirectWalkIn(company.id);
    }
  }
};
